/* Red de seguridad del cajon del carrito.

   Sintoma observado: al agregar pelota + personalizacion en un solo POST, el
   cajon abria con el total correcto pero sin la lista de articulos.
   Causa probable: el cajon conserva la clase 'is-empty' del momento en que la
   pagina cargo con el carrito vacio, y esa clase esconde la lista por CSS
   aunque el HTML nuevo si traiga los renglones.

   Este archivo hace dos cosas, en orden de menor a mayor agresividad:
   1. Quita 'is-empty' del cajon cada vez que el carrito cambia.
   2. Si aun asi no hay renglones visibles y el carrito si tiene articulos,
      manda a la pagina del carrito. Vale mas un salto que un carrito que
      parece vacio. */
(function () {
  var nativeFetch = window.fetch.bind(window);
  var checking = false;

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function unempty() {
    var nodes = document.querySelectorAll('cart-drawer, .cart-drawer, #CartDrawer, cart-drawer .drawer__inner, #CartDrawer .drawer__inner');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].classList.contains('is-empty')) nodes[i].classList.remove('is-empty');
    }
  }

  function rows() {
    return document.querySelectorAll(
      'cart-drawer .cart-item, #CartDrawer .cart-item, cart-drawer-items .cart-item, .cart-drawer .cart-item'
    ).length;
  }

  function drawerOpen() {
    var d = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
    if (!d) return false;
    return d.classList.contains('active') || d.classList.contains('is-open') || d.hasAttribute('open');
  }

  function check() {
    if (checking) return;
    checking = true;
    nativeFetch(routeRoot() + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        checking = false;
        if (!cart.item_count) return;
        unempty();
        setTimeout(function () {
          if (rows() === 0 && drawerOpen()) window.location = routeRoot() + 'cart';
        }, 500);
      })
      .catch(function () { checking = false; });
  }

  document.addEventListener('mb:cart:changed', function () { unempty(); setTimeout(check, 400); });

  var patched = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = typeof url === 'string' ? url : (url && url.url) || '';
    var isCart = href.indexOf('/cart/') !== -1;
    return patched.apply(this, arguments).then(function (res) {
      if (isCart) { setTimeout(unempty, 120); setTimeout(check, 600); }
      return res;
    });
  };

  if (window.MutationObserver) {
    var target = document.querySelector('cart-drawer, #CartDrawer');
    if (target) {
      new MutationObserver(function () { unempty(); }).observe(target, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });
    }
  }

  document.addEventListener('DOMContentLoaded', unempty);
})();
